import { Injectable, signal } from '@angular/core';

/** Page title shown in the main layout toolbar. */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private readonly titleSignal = signal('');

  readonly title = this.titleSignal.asReadonly();

  setTitle(title: string): void {
    this.titleSignal.set((title ?? '').trim());
  }

  clear(): void {
    this.titleSignal.set('');
  }
}
